import clearAllEvent from './clearAllEvent';
import toggleAllSelectEvent from './toggleAllSelectEvent';
import toggleSingleSelectEvent from './toggleSingleSelectEvent';

function curry(fn) {
  return (x) => (y) => (evt) => fn(x, y, evt);
}

export default (dispatch, getRows, tree) => (key, parentSlug, wrapups) => {
  const x = { dispatch, getRows, tree };
  const y = { key, parentSlug, wrapups };

  return {
    toggleSingleSelect:
      curry(toggleSingleSelectEvent)(x)(y),
    toggleAllSelect:
      curry(toggleAllSelectEvent)(x)(y),
    clearAll:
      curry(clearAllEvent)(x)(y),
  };
};



// WEBPACK FOOTER //
// ../~/eslint-loader!./js/directives/refineColumns/children/events/index.js